export default {
    user: {},
    mantemConectado: true,
    token: "",
    empresa: {}
};